import { FC } from 'react'
import classNames from 'classnames'
import { Email } from 'constants/regex'
import { useTranslation } from 'react-i18next'
import { EmailFormFieldProps as Props } from '../types'

const EmailFormFields: FC<Props> = ({
  emailLabel,
  formState,
  hasRepeat,
  hookFormSelector,
  isAlreadyCustomer,
  readOnly,
  register,
  repeatEmailLabel,
  watch
}) => {
  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation'])

  // Constants
  const { errors } = formState
  const watchEmail: string = watch('email')
  const emailKey: string = hookFormSelector?.email ?? 'email'
  const repeatKey: string = hookFormSelector?.repeatEmail ?? 'repeatEmail'

  return (
    <>
      {/* EMAIL */}
      <div className="form-input">
        <label htmlFor={emailKey}>{emailLabel ?? t('email', 'E-mailadres')}</label>
        <input
          type="email"
          className={classNames('is-block', { 'has-error': emailKey in errors || isAlreadyCustomer })}
          {...register(emailKey, { required: true, pattern: Email })}
          readOnly={readOnly}
        />
        {errors && errors[emailKey] && (
          <p className="margin-top-s margin-bottom-none is-red">
            {errors[emailKey].type === 'required' && t('validation:required')}
            {errors[emailKey].type === 'pattern' && t('validation:email')}
          </p>
        )}
        {isAlreadyCustomer && <p className="margin-top-s margin-bottom-m is-red">{t('emailAlreadyTaken', 'Je bent al klant.')}</p>}
      </div>

      {/* REPEAT EMAIL */}
      {hasRepeat && (
        <div className="form-input">
          <label htmlFor={repeatKey} className="margin-bottom-xs">
            {repeatEmailLabel ?? t('repeatEmail', 'Herhaal E-mailadres')}
          </label>
          <input
            type="email"
            className={classNames('is-block', { 'has-error': repeatKey in errors })}
            {...register(repeatKey, {
              required: true,
              pattern: Email,
              validate: (value: string) => value.trim() === watchEmail.trim()
            })}
            onPaste={(e) => e.preventDefault()}
            readOnly={readOnly}
          />
          {errors && errors[repeatKey] && (
            <p className="margin-top-s margin-bottom-none is-red">
              {errors[repeatKey].type === 'required' && t('validation:required')}
              {errors[repeatKey].type === 'pattern' && t('validation:email')}
              {errors[repeatKey].type === 'validate' && t('emailNotEqual', 'E-mailadressen komen niet overeen, controleer je even?')}
            </p>
          )}
        </div>
      )}
    </>
  )
}

export default EmailFormFields
